import cookies from "js-cookie";
import { removeAllCookies, setAuthCookies } from "helpers/cookieHelper";

let isRefreshing = false;
let failedQueue: (() => void)[] = [];

const processQueue = async () => {
  failedQueue.forEach((cb) => cb());
  failedQueue = [];
  isRefreshing = false;
};

const refreshAccessToken = async () => {
  const accessToken = cookies.get("accessToken");
  const refreshToken = cookies.get("refreshToken");

  const graphqlUrl = `${process.env.REACT_APP_API_URL}/graphql`;

  const response = await fetch(graphqlUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `JWT ${accessToken}`,
    },
    body: JSON.stringify({
      query: `mutation refreshTokens {
        refreshTokens(refreshToken: "${refreshToken}") {
          accessToken
          refreshToken
        }
      }`,
    }),
  });

  const data = await response.json();
  if (data?.data?.refreshTokens?.accessToken) {
    const newTokens = data.data.refreshTokens;
    setAuthCookies([
      { name: "accessToken", value: newTokens.accessToken },
      { name: "refreshToken", value: newTokens.refreshToken },
    ]);
    return newTokens.accessToken;
  }
  throw new Error("Unable to refresh token");
};

const fetchWithAuthRetry = async (input: RequestInfo, init: RequestInit = {}) => {
  const attempt = async () => {
    const token = cookies.get("accessToken");
    const companyId = cookies.get("companyId");

    const headers = new Headers(init.headers || {});
    if (token) headers.set("Authorization", `JWT ${token}`);
    if (companyId) headers.set("company-id", companyId);

    const response = await fetch(input, { ...init, headers });

    if (response.status === 401) throw new Error("Unauthorized");

    return response;
  };

  try {
    return await attempt();
  } catch (error: any) {
    if (error.message !== "Unauthorized") throw error;

    if (!isRefreshing) {
      isRefreshing = true;
      try {
        await refreshAccessToken();
        await processQueue();
      } catch (e) {
        removeAllCookies();
        window.location.href = "/login";
        throw e;
      }
    }

    return new Promise<Response>((resolve, reject) => {
      failedQueue.push(async () => {
        try {
          const result = await attempt();
          resolve(result);
        } catch (e) {
          reject(e);
        }
      });
    });
  }
};

export default fetchWithAuthRetry;
